<template>
  <sp-row class="sp-slot-cards" :rowgap="rowGap" :columngap="columnGap">
    <sp-col v-for="(entry, index) in visibleEntries" :key="index" sm="4" cols="3" md="4">
      <EntryCard :is-mobile="isSmScreen" :entry="entry" @show-more-slots="showMoreSlots" />
    </sp-col>

    <sp-col v-if="hasMoreEntries" align-items="center" align-self="center" sm="12" md="12">
      <sp-icon v-if="!isSmScreen" name="event-color" size="l"></sp-icon>
      <sp-button variant="appearance-link" @click="showMoreSlots">Full Schedule</sp-button>
    </sp-col>
  </sp-row>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "../../composables/breakpoints";
import { toCssSpacingProperty, toJSON } from "../../utils/props";
import EntryCard from "./components/EntryCard.ce.vue";

const emit = defineEmits(["show-more-slots"]);

const props = defineProps({
  /**
   * The entries to display.
   *
   * @type {Array|String} If a string is provided, it will be parsed as JSON.
   * @default []
   */
  entries: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * The maximum number of entries to display.
   * If the number of entries exceeds this value, a "Show More" button will be displayed.
   *
   * @type {Number}
   * @default 3
   */
  maxEntries: {
    type: Number,
    default: 3,
  },
});

const { isSmScreen } = useBreakpoints();

const rowGap = toCssSpacingProperty(12);
const columnGap = computed(() => toCssSpacingProperty(isSmScreen.value ? 2 : 4));

/**
 * The prop `entries` as an array of objects.
 *
 * @type {import('vue').ComputedRef<Array<Object>>}
 */
const entries = computed(() => toJSON(props.entries, true));
const visibleEntries = computed(() => entries.value.slice(0, props.maxEntries));
const hasMoreEntries = computed(() => entries.value.length > visibleEntries.value.length);

function showMoreSlots({ date }) {
  emit("show-more-slots", { date });
}
</script>

<style lang="scss">
:host {
  display: block;
  width: 100%;
}
</style>

<style scoped lang="scss">
.sp-slot-cards {
  --row-column-gap: v-bind(columnGap);
}
</style>
